const puzzle = {
  id: "riDvoNI07SYuGhTIxFV1",
  name: "Shape of Life",
  rebuses: [
    {
      style: {},
      solutionInfo: {
        solvedText: "Egg",
        possibleSolutions: [
          {
            id: "70c1f544-2af6-48bb-bb8b-768e7f598fd4",
            value: "Egg",
          },
        ],
        type: "text",
      },
      clues: [
        {
          id: "97b051b4-24a3-4b3f-996b-301c9e0fc82d",
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            "The graph of a given equation looks like something. Find out what.",
          dependsOn: [],
          clueValues: [
            {
              id: "8642a997-5cfd-4444-8094-c651fb53b054",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "image",
              subtext: "",
              value: "mBql4OKG.png",
            },
            {
              subtext: "",
              value: "PVnrvtra.png",
              type: "image",
              id: "56d07837-74fb-43d7-ae12-581dcfc7362e",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          clueGroup: 0,
        },
      ],
      id: "2212f733-0f30-4f00-8563-6c8ea17b25b2",
    },
    {
      clues: [
        {
          subtext: "",
          id: "1-2-3-4",
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          helperText: "",
          clueGroup: 0,
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Writers",
              id: "2-3d08-4a55-2-3ca4ef1e2fc2",
              type: "text",
              subtext: "",
            },
          ],
          style: {
            width: "calc(100% - 10px)",
          },
        },
        {
          subtext: "",
          id: "d2587207-a3df-4148-bc0f-af6e8cc9c500",
          dependsOn: [],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Arthur C. Clarke",
                id: "ac8a2504-fa24-4a86-ba83-882e2633f119",
              },
              {
                value: "Arthur Charles Clarke",
                id: "e0af4e00-b1f6-43ee-a160-c49b33bd8bfb",
              },
              {
                id: "435f6d76-ad8b-4468-a5a6-7d75b9f2222b",
                value: "Sir Arthur Charles Clarke",
              },
              {
                value: "Arthur Clarke",
                id: "8403b12f-b57a-4835-b4a9-8470235e507e",
              },
            ],
            solvedText: "Arthur C. Clarke",
          },
          helperText: "Date of birth: 16 December 1917.",
          clueGroup: 0,
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "9EgyMQg2.png",
              id: "32dda339-3d08-4a55-b109-3ca4ef1e2fc2",
              type: "image",
              subtext: "",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          clueValues: [
            {
              id: "d247e62b-5b68-4d24-a641-844199a8d02a",
              type: "image",
              value: "podia27o.png",
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "T.M. Wright",
                id: "68ebe72c-9417-426a-9f6b-c12b8f4f76cc",
              },
              {
                id: "87e783d5-c38a-4735-b26f-a2818039d19e",
                value: "Terrance Michael Wright",
              },
              {
                value: "Terrance Wright",
                id: "2f9ae9fc-13e5-4c53-9992-b926b3877646",
              },
            ],
            solvedText: "T.M. Wright",
          },
          subtext: "",
          helperText: "Date of birth: 9 September 1947.",
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          clueGroup: 0,
          id: "3db7df75-8d42-42a5-856b-872723828b60",
        },
        {
          id: "5e8932e4-d51a-40d4-9adb-30adff5de087",
          dependsOn: [],
          clueGroup: 0,
          solutionInfo: {
            solvedText: "Robert Louis Stevenson",
            possibleSolutions: [
              {
                value: "Robert Louis Stevenson",
                id: "a8fcd9fa-4811-49a3-81be-0becb7baab8b",
              },
              {
                id: "4f771b95-32b1-4dd7-a86c-9f7413ff23ec",
                value: "Robert Lewis Balfour Stevenson",
              },
              {
                id: "ebd2835f-bd2e-4813-854e-f78e7cf18c35",
                value: "Robert Stevenson",
              },
            ],
            type: "text",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          helperText: "Date of birth: 13 November 1850.",
          clueValues: [
            {
              value: "S5FNMp5q.png",
              id: "f941094a-1467-4c46-8076-854a85c2a57c",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
            },
          ],
        },
        {
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          helperText: "A book written by Arthur C. Clarke (in 1963.)",
          id: "fdc0eb15-60f4-4698-a3fe-4caa353eba03",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [
            {
              id: "e9b118df-46e4-432e-917d-39f97712ad20",
              value: "d2587207-a3df-4148-bc0f-af6e8cc9c500",
            },
            {
              id: "fe4aecba-53f8-4b2e-9d0e-e93a6c8be7ca",
              value: "3db7df75-8d42-42a5-856b-872723828b60",
            },
            {
              value: "5e8932e4-d51a-40d4-9adb-30adff5de087",
              id: "efca6bf9-3456-44ea-9947-80a8cde3d097",
            },
          ],
          clueValues: [
            {
              type: "text",
              subtext: "Arthur C. Clarke",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Dolphin",
              id: "8cfaf8c5-5127-42ee-b9b9-43539b01a5f1",
            },
          ],
        },
        {
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          id: "59af03db-bbcd-4686-a08b-989cef3df0e1",
          subtext: "",
          helperText: "A book written by T.M Wright (in 1988.)",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "The",
              subtext: "T.M. Wright",
              id: "52e0e24c-de5c-454b-b561-979a5b9a5501",
              type: "text",
            },
          ],
          dependsOn: [
            {
              value: "5e8932e4-d51a-40d4-9adb-30adff5de087",
              id: "ed9928fb-7dd9-458b-9ade-7d81dc704629",
            },
            {
              value: "3db7df75-8d42-42a5-856b-872723828b60",
              id: "0f23e56e-e05d-4c60-9b29-8302a7ce388c",
            },
            {
              id: "30a25f4d-3770-4053-9622-895d49ec6add",
              value: "d2587207-a3df-4148-bc0f-af6e8cc9c500",
            },
          ],
        },
        {
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "Island",
            type: "text",
          },
          helperText: "A book written by Robert Louis Stevenson (in 1883.)",
          clueValues: [
            {
              value: "Treasure",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Robert Louis Stevenson",
              type: "text",
              id: "d3d78158-632f-406a-bea3-21072e996919",
            },
          ],
          id: "56356068-5a61-4e5e-b212-4849f3ed8426",
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [
            {
              value: "5e8932e4-d51a-40d4-9adb-30adff5de087",
              id: "b25054d8-fd5b-4f5b-a0bc-629a7ef3304b",
            },
            {
              id: "a7b13ae6-3b9b-433d-a53c-906aa8f1b778",
              value: "3db7df75-8d42-42a5-856b-872723828b60",
            },
            {
              id: "ef55650a-9281-4c47-bb71-7014de4936f1",
              value: "d2587207-a3df-4148-bc0f-af6e8cc9c500",
            },
          ],
        },
      ],
      style: {},
      id: "b1dcaa8b-3070-4005-93d1-cfb15995f883",
      solutionInfo: {
        solvedText: "Island",
        type: "text",
        possibleSolutions: [
          {
            value: "Island",
            id: "d31aa2bf-135a-4ba1-88c5-b086869427b2",
          },
        ],
      },
    },
    {
      id: "85459f14-ad1b-4e73-8856-d63baaa158b0",
      solutionInfo: {
        solvedText: "Bunny",
        possibleSolutions: [
          {
            id: "4fb9adbf-a6e6-482f-bef8-419ddf1e1671",
            value: "Bunny",
          },
        ],
        type: "text",
      },
      clues: [
        {
          dependsOn: [],
          helperText: "Find a path out of the labyrinth.",
          clueValues: [
            {
              value: "bpp0jiSe.png",
              subtext: "",
              id: "b17c5248-7724-4df3-b9b2-fbc61f5ab3a5",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          solutionInfo: {
            type: "text",
            solvedText: "Small rabbit",
            possibleSolutions: [
              {
                value: "Small rabbit",
                id: "e4efd26b-de16-4254-bdd4-dd2f1c0bccd8",
              },
            ],
          },
          clueGroup: 0,
          id: "249648dd-b598-4ad4-913c-de2897463123",
        },
        {
          helperText: "",
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "1ba23ebb-2592-4676-9fae-03921377f34a",
              type: "text",
              subtext: "",
              value: "Synonims: hare, coney",
            },
          ],
          id: "8579d2b2-8919-4df2-9981-1a9a1506547e",
          dependsOn: [
            {
              value: "249648dd-b598-4ad4-913c-de2897463123",
              id: "78d3795b-ccf9-411c-a9b5-f6151ebd7de9",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 0,
        },
      ],
      style: {},
    },
    {
      clues: [
        {
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          id: "c093a016-0396-47d0-b7c2-868cb65e8433",
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 0,
          subtext: "",
          clueValues: [
            {
              subtext: "",
              value: "Egg",
              id: "d31dc7b3-146e-4273-bac3-2e9ca7f650ce",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "They are usually colored on one day.",
        },
        {
          clueValues: [
            {
              subtext: "",
              value: "Island",
              id: "4ebde83f-e043-419d-a799-a9bdbd0fe173",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          clueGroup: 0,
          id: "009d81a4-99de-43e1-b5d0-d5d4dd9b9925",
          subtext: "",
          style: {
            width: "calc(33% - 10px)",
          },
          helperText:
            "The island most famous for its many statues, called moai.",
          dependsOn: [],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
        },
        {
          clueValues: [
            {
              subtext: "",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              id: "5b114796-fa2b-43d1-ab8b-747c199ddbab",
              value: "Bunny",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          helperText: "Symbol of a holiday.",
          style: {
            width: "calc(33% - 10px)",
          },
          id: "4e80e76a-3af2-4d83-990d-416282123684",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
        },
      ],
      solutionInfo: {
        type: "text",
        solvedText: "Easter",
        possibleSolutions: [
          {
            value: "Easter",
            id: "cfe62d5f-166b-4246-93a0-275dc82f0179",
          },
        ],
      },
      style: {},
      id: "68d6c3a6-00ec-42ba-9766-955602e95ce5",
    },
  ],
};

export default puzzle;
